export default __webpack_public_path__ + "static/media/icon_advertisement.43a6727f.svg";